module.exports = __webpack_public_path__ + "static/img/row-vertical.fb85013b.svg";